import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api.service/api.service';
import { environment } from 'src/environments/environment';

export interface VSDKMeeting {
  userId?: string;
  meetingId?: string;
  apiKey?: string;
  userMeetingId?: string;
  disabled: boolean;
  createdAt: string;
  updatedAt: string;
  id: string;
  roomId: string;
  customRoomId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MeetingsService extends ApiService {

  /**
   * Validation d'une room VideoSDK.
   *
   * Angular appelle Spring Boot.
   * Spring Boot appelle ensuite VideoSDK avec
   * VIDEOSDK_API_TOKEN.
   */
  validateMeeting(
    meetingId: string
  ): Observable<any> {

    return this.http.get<any>(`https://api.videosdk.live/v2/rooms/validate/${meetingId}`)
  }
}